import styled, { css } from 'styled-components';

import { styledReset, styledTypography } from '@pkg/primitives';

import { tokens } from './CartSummary.tokens';

const typographyBase = css`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    letter-spacing: -0.02em;
`;

export const StyledCartSummary = styled.ul`
    ${styledReset.list};
    display: grid;
    gap: ${tokens.list.gap}px;
`;

export const Item = styled.li`
    display: flex;
    justify-content: space-between;
`;

export const Label = styled.p`
    ${typographyBase};
    font-size: ${tokens.item.fontSize}px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.5);
`;

export const Value = styled.p`
    ${typographyBase};
    font-size: ${tokens.item.fontSize}px;
    font-weight: 600;
`;
